import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FormContextProvider, DisplaySpinnerContext } from "../../../context/ContextIndex";
import { AppForm, DynamicFormContainer, notifyToast, ToastType, TabPanel } from "../../../components";
import { getServiceTypeDefaultValue, getServiceTypeSchema } from "./Schema";
import { selectSessionConfig } from "../../../store/store-selector";
import { saveServiceType } from "../api-handler/api-handler";
import AppFormRootContainer from "../../../components/app-components/app-form-root-container/AppFormRootContainer";

const CreateServiceTypeForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const EditServiceTypeId = searchParams.get("typeid");
  const spinnerCtx = useContext(DisplaySpinnerContext);
  const settingsConfig = useSelector(selectSessionConfig);
  const navigationData = location.state;

  const [formdata, setFormdata] = useState({
    schema: getServiceTypeSchema(),
    appformdata: null,
  });

  const defaultValue = getServiceTypeDefaultValue();

  const handleCancel = () => {
    try {
      navigate("/servicetypelist");
    } catch (err) {
      alert(err);
    }
  };

  const onServiceTypeSubmit = async (data, formhandler) => {
    console.log("onSectorSubmit");
    const { reset, clearErrors } = formhandler;
    try {
      clearErrors();
      spinnerCtx.setLoadingIndicator(true);
      const status = await saveServiceType(data, {
        EditServiceTypeId,
        settingsConfig,
        formdata: formdata.appformdata,
      });

      if (status?.responseStatus === 200) {
        notifyToast("Sent for Approval", ToastType.SUCCESS);
        handleCancel();
      } else {
        notifyToast(status.errorMessage ? status.errorMessage : "Service type creation failed", ToastType.ERROR);
        spinnerCtx.setLoadingIndicator(false);
      }
      if (status?.error) {
        reset(
          { ...data },
          {
            keepValues: true,
            keepSubmitCount: false,
            keepDirty: true,
            keepTouched: true,
          }
        );
      }
    } catch (err) {
      reset(
        { ...data },
        {
          keepValues: true,
          keepSubmitCount: false,
          keepDirty: true,
          keepTouched: true,
        }
      );
      alert(err);
    }
  };

  useEffect(() => {
    const setFormSchema = () => {
      try {

        let _formData = navigationData ? { ...navigationData } : null;

        if (_formData) {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getServiceTypeSchema(),
            appformdata: getServiceTypeDefaultValue(_formData),
          }));
        } else {
          setFormdata((prevstate) => ({
            ...prevstate,
            schema: getServiceTypeSchema(),
          }));
        }

      } catch (err) {
        alert(err);
      } finally {
        spinnerCtx.setLoadingIndicator(false);
      }
    };

    spinnerCtx.setLoadingIndicator(true);
    setFormSchema();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppFormRootContainer>
      <TabPanel
        tabs={[
          {
            icon: "",
            label: t("navigationMenu.serviceType"),
            children: (
              <FormContextProvider schema={formdata.schema} defaultValues={defaultValue} appformdata={formdata.appformdata}>
                <AppForm onSubmit={onServiceTypeSubmit}>
                  <DynamicFormContainer
                    header={EditServiceTypeId ? t("createServiceType.editServiceType") : t("createServiceType.header")}
                    onCancel={handleCancel}
                  />
                </AppForm>
              </FormContextProvider>
            ),
          },
        ]}
        selectedTab="0"
        onTabChange={() => { }}
      />
    </AppFormRootContainer>
  );
};

export default CreateServiceTypeForm;
